function findGoogleAddressComponent(placeData, componentName) {
    var result = placeData.address_components.filter(function(el) {
        return el.types[0] === componentName;
    });
    if (result && Array.isArray(result) && result.length) {
        return result[0].short_name;
    } else {
        return false;
    }
}

document.querySelectorAll('[data-mapcomplete=input]').forEach(function(el) {
    el.addEventListener('keydown', function(e) {
        if (e.which === 10 || e.which === 13) {
            e.preventDefault();
            return false;
        }
    });
});


document.querySelectorAll('input[type=tel]').forEach(function(input) {
    input.addEventListener('change', function() {
        const phoneNumberString = input.value;

        var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
        var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
            input.value = '(' + match[1] + ') ' + match[2] + '-' + match[3];
        }
    });
});



/* exported initGooglePlaces */ // but actually a callback
/* global google */
function initGooglePlaces() {
    document.querySelectorAll('.map-lookup-container').forEach(function(container) {
        const mapCompleteInput = container.querySelector('[data-mapcomplete=input]');
        if (!mapCompleteInput) {
            return;
        }

        const autocompleter = new google.maps.places.Autocomplete(mapCompleteInput, {
            componentRestrictions: { country: 'us' },
            origin: { lat: -72.74379350000001, lng: 41.31777181346496 },
            fields: ['address_component', 'geometry.location']
        });

        autocompleter.addListener('place_changed', function() {
            var resultLocation = autocompleter.getPlace();
            if (!resultLocation || !resultLocation.address_components) { return; }

            const address = {
                address: findGoogleAddressComponent(resultLocation, 'street_number') + ' ' + findGoogleAddressComponent(resultLocation, 'route'),
                city: findGoogleAddressComponent(resultLocation, 'locality'),
                state: findGoogleAddressComponent(resultLocation, 'administrative_area_level_1'),
                zip: findGoogleAddressComponent(resultLocation, 'postal_code'),
                lat: resultLocation.geometry.location.lat(),
                lng: resultLocation.geometry.location.lng()
            };
            if (container.hasAttribute('data-validatedeliveryzip')) {
                getTimesForZip(address.zip);
            }
            mapLookupFillInData(container, address);
            mapDisplayPreview(container, address);
        });

        ['first-name', 'last-name', 'address-2'].forEach(function(part) {
            const valueEl = container.querySelector('.map-lookup-' + part);
            const displayEl = container.querySelector('.address-lookup-confirmation-' + part);
            if (valueEl && displayEl) {
                valueEl.addEventListener('blur', function() {
                    displayEl.textContent = valueEl.value;
                });
                valueEl.dispatchEvent(new Event('blur'));
            }
        });
    });
}
function mapLookupFillInData(container, address) {
    ['address', 'city', 'state', 'zip', 'lat', 'lng'].forEach(function(part) {
        if (container.querySelector('[data-mapcomplete=' + part + ']')) {
            container.querySelector('[data-mapcomplete=' + part + ']').value = address[part];
        }
    });
}

function mapDisplayPreview(container, address) {
    ['address', 'city', 'state', 'zip'].forEach(function(part) {
        const partEl = container.querySelector('.address-lookup-confirmation-' + part);
        if (partEl) {
            partEl.textContent = address[part];
        }
    });
}


/* exported number_format */
function number_format (number, decimals, dec_point, thousands_sep) {
    // Strip all characters but numerical ones.
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s = '',
        toFixedFix = function (n, prec) {
            var k = Math.pow(10, prec);
            return '' + Math.round(n * k) / k;
        };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
}

function resetDateText(data) {
    document.querySelectorAll('input[name=delivery_date]').forEach(function(dateInput) {
        if (dateInput.value.toLowerCase().startsWith(data[0])) {
            dateInput.checked = true;
            var dates = document.getElementsByClassName('delivery_date');
            for (var date of dates) {
                date.innerText = dateInput.value;
            }
        } else {
            dateInput.checked = false;
        }
    });
    if (data[1] == "afternoon") {
        document.getElementById("nav_delivery_early").style.display = "inline";
        document.getElementById("nav_delivery_normal").style.display = "none";
        document.getElementById("delivery_early_hours").style.display = "inline";
        document.getElementById("delivery_normal_hours").style.display = "none";
    } else {
        document.getElementById("nav_delivery_early").style.display = "none";
        document.getElementById("nav_delivery_normal").style.display = "inline";
        document.getElementById("delivery_early_hours").style.display = "none";
        document.getElementById("delivery_normal_hours").style.display = "inline";
    }

    document.querySelectorAll('input[name=delivery_timeframe]').forEach(function(timeInput) {
        if (timeInput.id.endsWith(data[1])) {
            timeInput.checked = true;
        } else {
            timeInput.checked = false;
        }
    });
    document.getElementById("fulfillment_instructions_confirmed").checked = false;
}
function validateDeliveryAvailability(delivery_options) {
	var afternoon_select_options = document.getElementById('afternoon_select').options;
    for (var i = 0; i < afternoon_select_options.length; i++) {
        if (delivery_options.includes(afternoon_select_options[i].value)) {
            afternoon_select_options[i].style.display = "inline";
            afternoon_select_options[i].selected = true;
        } else {
            afternoon_select_options[i].style.display = "none";
            afternoon_select_options[i].selected = false;
        }
    }
    var data = document.getElementById('afternoon_select').value.split("_");
    resetDateText(data);
}

function getTimesForZip(zip) {
    const validationFD = new FormData();
    validationFD.append('zipcode', zip);
    fetch('/store/cart/validateDeliveryZip/', {
        method: 'POST',
        body: validationFD
    })
    .then(response => response.json())
    .then(data => {
        if (data.status !== 'OK') {
            alert("Sorry, The Strong Kitchen doesn't deliver to your zip code at this time. Try picking up at one of our convenient partner gyms!");
        }
         else {
            validateDeliveryAvailability(data.options);
        }
    });
}
/* exported number_format */

// function number_format (number, decimals, dec_point, thousands_sep) {
//     // Strip all characters but numerical ones.
//     number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
//     var n = !isFinite(+number) ? 0 : +number,
//         prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
//         sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
//         dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
//         s = '',
//         toFixedFix = function (n, prec) {
//             var k = Math.pow(10, prec);
//             return '' + Math.round(n * k) / k;
//         };
//     // Fix for IE parseFloat(0.55).toFixed(0) = 0;
//     s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
//     if (s[0].length > 3) {
//         s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
//     }
//     if ((s[1] || '').length < prec) {
//         s[1] = s[1] || '';
//         s[1] += new Array(prec - s[1].length + 1).join('0');
//     }
//     return s.join(dec);
// }

/* 
 * Loosely based off of
 * https://github.com/inexorabletash/polyfill/blob/master/xhr.js
 * Spec:
 * https://xhr.spec.whatwg.org/#interface-formdata
*/

(function(global) {
	if (!('window' in global && 'document' in global))
	  return;
  
	(function() {
	  if ('FormData' in global && 'set' in global.FormData.prototype)
		return;
  
	  function FormData(form) {
		this._data = [];
		if (!form) return;
		for (var i = 0; i < form.elements.length; ++i) {
		  var element = form.elements[i];
		  if (element.name !== '')
			this.append(element.name, element.value);
		}
	  }
  
	  FormData.prototype = {
		append: function(name, value, filename) {
		  var entryName = String(name);
		  var entryValue = value;
		  if ('Blob' in global && value instanceof global.Blob) {
			entryValue = new File(value, "blob");
		  }
		  if (filename && 'File' in global && value instanceof global.File) {
			entryValue = new File(entryValue, filename);
		  }
  
		  this._data.push([entryName, entryValue]);
		},
  
		toString: function() {
		  return this._data.map(function(pair) {
			return encodeURIComponent(pair[0]) + '=' + encodeURIComponent(pair[1]);
		  }).join('&');
		}
	  };
  
	  FormData.prototype.set = function(name, value, filename) {
		var didSet = false;
  
		for (var i = 0; i < this._data.length; ++i) {
		  if (this._data[i][0] === name) {
			if (didSet) {
			  this._data.splice(i, 1);
			  --i;
			} else {
			  this._data[i][1] = value;
			  if (filename && 'File' in global && value instanceof global.File) {
				this._data[i][1].name = filename;
			  }
			  didSet = true;
			}
		  }
		}
  
		if (!didSet) {
		  this.append(name, value, filename);
		}
	  }
  
	  FormData.prototype.get = function(name) {
		for (var i = 0; i < this._data.length; ++i) {
		  if (this._data[i][0] === name) {
			return this._data[i][1];
		  }
		}
		return null;
	  }
  
	  FormData.prototype.getAll = function(name) {
		var results = [];
		for (var i = 0; i < this._data.length; ++i) {
		  if (this._data[i][0] === name) {
			results.push(this._data[i][1]);
		  }
		}
		return results;
	  }
  
	  FormData.prototype.has = function(name) {
		return this.get(name) !== null;
	  }
  
	  FormData.prototype.delete = function(name) {
		for (var i = 0; i < this._data.length; ++i) {
		  if (this._data[i][0] === name) {
			this._data.splice(i, 1);
			--i;
		  }
		}
	  }
  
	  function newIterator(data, modifier) {
		return {
		  next: function() {
			if (this._i >= this._data.length) {
			  return { done: true };
			}
  
			++this._i;
			return {
			  done: false,
			  value: modifier(this._data[this._i-1]),
			};
		  },
		  _i: 0,
		  _data: data,
		};
	  }
  
	  FormData.prototype.entries = function() {
		return newIterator(this._data, function(entry) {
		  return [entry[0], entry[1]];
		});
	  }
  
	  FormData.prototype.keys = function() {
		return newIterator(this._data, function(entry) {
		  return entry[0];
		});
	  }
  
	  FormData.prototype.values = function() {
		return newIterator(this._data, function(entry) {
		  return entry[1];
		});
	  }
  
	  FormData.prototype[Symbol.iterator] = function() {
		return this._data[Symbol.iterator]();
	  }
  
	  global.FormData = FormData;
	  var send = global.XMLHttpRequest.prototype.send;
	  global.XMLHttpRequest.prototype.send = function(body) {
		if (body instanceof FormData) {
		  this.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
		  arguments[0] = body.toString();
		}
		return send.apply(this, arguments);
	  };
	}());
  
  }(self));
/* global braintree, fbq, number_format */
const deliveryMinimum = 50;
if (window.NodeList && !NodeList.prototype.forEach) {
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (var i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}



document.querySelector('.hamburger').addEventListener('click', function(e) {
	e.preventDefault();
	this.classList.toggle('is-active');
	document.querySelector('#site-nav ul').classList.toggle('is-active');
	document.querySelector('html').classList.toggle('nav-active');
});


/* Sticky header component */
(function() {
	var ticking = false;
	window.addEventListener('scroll', function() {
		if (!ticking) {
			window.requestAnimationFrame(function() {
				if (window.innerWidth >= 768 && window.scrollY > 175) {
					document.documentElement.classList.add("scrolled");
				} else {
					document.documentElement.classList.remove("scrolled");
				}
				ticking = false;
			});
		}
		ticking = true;
	});
}());

/* Open external links in new window */
document.querySelectorAll('a').forEach(function(el) {
	if (el.hasAttribute('href') && el.getAttribute('href').indexOf('http') === 0) {
		el.setAttribute('target', '_blank');
	}
});



/* menu navigation on mobile */
var menuNavigation = document.querySelector('#menu-navigation');
if (menuNavigation) {
	menuNavigation.addEventListener('click', function(e) {
		if (e.target.tagName !== "A") {
			e.preventDefault();
			e.stopPropagation();
			document.querySelector('#menu-navigation ul').classList.toggle("active");
			return false;
		}
	});
}

/* product option navigation on mobile */
var showProductOptions = function(e) {
	if (e.target.tagName === 'SELECT') { return; } /* Avoid taps on select element */
	this.parentNode.classList.toggle('open');
};
var productOptionHeaders = document.querySelectorAll(".product-option-header");
productOptionHeaders.forEach(function(el) {
	el.addEventListener('click', showProductOptions);
});



function alertError(e) {
	console.group();
	console.error(e.name);
	console.error(e.message);
	console.groupEnd();
}

function alertMessage(msg, data) {
	if (data) {
		console.group();
		console.error(msg);
		console.error(data);
		console.groupEnd();
	} else {
		console.error(msg);
	}
}


var updateCartItemQuantities = function(updates) {
	var request = new XMLHttpRequest();
	request.open('POST', '/cart/updateItem', true);
	request.onload = function() {
		if (request.status >= 200 && request.status < 400) {
			var resp = JSON.parse(request.responseText);
			//void(resp);
		//	getCartData();
			updateCartDisplay(resp);

			fbq('track', 'AddToCart', {content_ids: updates.map(function(el) { return el.option_id; })});
		} else {
			alertMessage('AJAX response error in updateCartitemQty', request);
		}
	};
	request.onerror = function() {
		alertMessage('Server response error in updateCartItemQty', request);
	};

	var itemFD = new FormData();
	itemFD.append('multi_updates', JSON.stringify(updates));

	request.send(itemFD);
};

/*var updateCartItemQty = function(optionID, qty) {
	if (isNaN(optionID)) {
		throw new ProductUpdateException("optionID cannot be NaN", optionID);
	}
	if (isNaN(qty)) {
		throw new ProductUpdateException("qty cannot be NaN", qty);
	}
	
	fbq('track', 'AddToCart', {content_ids: optionID});

	var request = new XMLHttpRequest();
	request.open('POST', '/store/cart/addItem', true);
	request.onload = function() {
		if (request.status >= 200 && request.status < 400) {
			var resp = JSON.parse(request.responseText);
			void(resp);
			getCartData();
		} else {
			alertMessage('AJAX response error in updateCartitemQty', request);
		}
	};
	request.onerror = function() {
		alertMessage('Server response error in updateCartItemQty', request);
	};


	var itemFD = new FormData();
	itemFD.append('optionID', optionID);
	itemFD.append('qty', qty);

	request.send(itemFD);
};

function ProductUpdateException(message, value) {
	this.message = message + ': ' + value;
	this.name = 'ProductUpdateException';
}*/

function updateCartItemQty(optionID, qty) {
	fbq('track', 'AddToCart', {content_ids: optionID});

	var request = new XMLHttpRequest();
	request.open('POST', '/cart/updateItem/', true);
	request.onload = function() {
		if (request.status >= 200 && request.status < 400) {
			var resp = JSON.parse(request.responseText);
			void(resp);
			updateCartDisplay(resp);
		} else {
			alertMessage('AJAX response error in updateCartitemQty', request);
		}
	};
	request.onerror = function() {
		alertMessage('Server response error in updateCartItemQty', request);
	};


	var itemFD = new FormData();
	itemFD.append('option', optionID);
	itemFD.append('qty', qty);

	request.send(itemFD);
}

var productOptionDropdowns = document.querySelectorAll('.product-qty');
productOptionDropdowns.forEach(function(el) {
	el.addEventListener('change', function() {
		var optionID = parseInt(this.getAttribute('data-optionid')),
			qty = parseInt(this.value);

		try {
			updateCartItemQty(optionID, qty);
		} catch (e) {
			alertError(e);
		}
	});
});


var globalCart;
function getCartData(successFunction) {
	var request = new XMLHttpRequest();
	request.open('GET', '/cart/toJSON', true);
	request.onload = function() {
		if (request.status >= 200 && request.status < 400) {
			var cartResponse = JSON.parse(this.responseText);
			globalCart = cartResponse;
			updateCartDisplay(cartResponse);
			if (typeof successFunction === "function") {
				successFunction(cartResponse);
			}
		} else {
			alertMessage('AJAX response error in getCartData', request);
		}
	};
	request.error = function() {
		alertMessage('Server response error in getCartData', request);
	};
	request.send();
}

function updateCartDisplay(cartData) {
	var shoppingCartIcon = document.querySelector('#shoppingcart-icon');
	if (cartData.items.length) {
		shoppingCartIcon.classList.add('has-items');
		shoppingCartIcon.parentNode.setAttribute('data-cartitems', cartData.items.length);
	} else {
		shoppingCartIcon.classList.remove('has-items');
		shoppingCartIcon.parentNode.removeAttribute('data-cartitems');
	}

	if (document.getElementById('checkout-form') && !document.getElementById('checkout-form').classList.contains('package-checkout')) {
		if (cartData.items.length === 0) {
			document.getElementById('checkout-container').classList.add('hidden');
			document.getElementById('checkout-empty').classList.remove('hidden');
		} else {
			document.getElementById('checkout-container').classList.remove('hidden');
			document.getElementById('checkout-empty').classList.add('hidden');
		}

		if (cartData.delivery_type === 'delivery' && (parseFloat(cartData.item_subtotal) >= parseFloat(deliveryMinimum))) {
			document.querySelector('#checkout-delivery').classList.remove('hidden');
			document.querySelector('#checkout-pickup').classList.add('hidden');
			document.querySelectorAll('#checkout-delivery .form-field.required').forEach(function(el) {
				el.setAttribute('required', true);
			});
		} else {
			document.querySelector('#checkout_delivery_pickup').checked = true;
			document.querySelector('#checkout-delivery').classList.add('hidden');
			document.querySelector('#checkout-pickup').classList.remove('hidden');
			document.querySelectorAll('#checkout-delivery .form-field.required').forEach(function(el) {
				el.removeAttribute('required');
			});
		}

		if (cartData.premium_item_total > 0) {
			document.querySelector('#premium-row').classList.remove('hidden');
			document.querySelector('#overview-cart-premium').innerText = cartData.premium_item_total;
		} else {
			document.querySelector('#premium-row').classList.add('hidden');
			document.querySelector('#overview-cart-premium').innerText = cartData.premium_total;
		}

		if (cartData.discount_amount) {
			const discountRow = document.querySelector('#discount-row');
			discountRow.classList.remove('hidden');
			//document.querySelector('#overview-cart-discount').innerText = cartData.discount_applied;
			const discountList = document.createElement('ul');
			cartData.discounts.forEach(function(discount) {
				const discountItem = document.createElement('li');
				discountItem.innerText = discount.description + ' $' + discount.value;
				discountList.appendChild(discountItem);
			});
			if (discountRow.querySelector('ul')) {
				discountRow.querySelector('ul').remove();
			}
			document.querySelector('#overview-cart-discount').appendChild(discountList);
			
			// if (cartData.discount_amount) {
			// 	document.querySelector('#overview-cart-discount').innerText += " ($" + number_format(cartData.discount_amount, 2) + ")";
			// }
		} else {
			document.querySelector('#discount-row').classList.add('hidden');
			document.querySelector('#overview-cart-discount').innerText = '';
		}

		if (cartData.delivery_type === 'pickup') {
			document.getElementById('overview-delivery-label').innerText = 'Pickup';
			document.getElementById('overview-delivery-amount').innerText = '0.00';
		} else {
			document.getElementById('overview-delivery-label').innerText = 'Delivery';
			document.getElementById('overview-delivery-amount').innerText = number_format(cartData.fulfillment_total, 2);
		}

		

		document.getElementById('overview-cart-subtotal').innerText = number_format(cartData.item_subtotal, 2);
		document.getElementById('overview-cart-tax').innerText = number_format(cartData.tax, 2);
		document.getElementById('overview-cart-grandtotal').innerText = number_format(cartData.grand_total, 2);

		document.querySelector('[name=item_total]').value = cartData.item_subtotal;
		document.querySelector('[name=tax]').value = cartData.tax;
		document.querySelector('[name=delivery]').value = cartData.fulfillment_total;
		document.querySelector('[name=grand_total]').value = cartData.grand_total;
	}

	var uniqueProductIDs = Array.from(new Set (cartData.items.flatMap(function(el) { return el.purchasable_id; })));

	//#region update checkout page rows
	if (document.body.getAttribute('data-page') === 'checkout') {
		document.querySelectorAll(".checkout-product").forEach(function(checkoutProd) {
			if (uniqueProductIDs.indexOf(parseInt(checkoutProd.getAttribute('data-productid'))) === -1) {
				checkoutProd.remove();
			}
		});
	}
	//#endregion

	//#region update product-in-cart signifiers
	if (document.body.getAttribute('data-page') === 'menus') {
		document.querySelectorAll('.product').forEach(function(itemInListing) {
			itemInListing.querySelector('.item-is-in-cart-container text').textContent = '';
			itemInListing.querySelector('.item-is-in-cart-container').classList.add('hidden');
		});
		

		uniqueProductIDs.forEach(function(productID) {
			var itemInListing = document.querySelector(".product[data-productid='" +productID + "']");
			if (!itemInListing) { return; }

			var thisProductInCart = cartData.items.filter(function(itemInCart) {
				return itemInCart.purchasable_id === productID;
			});

			var totalOfThisItemInCart = thisProductInCart.reduce(function(tot, item) {
				return tot + item.qty;
			}, 0);

			if (totalOfThisItemInCart > 0) {
				itemInListing.querySelector('.item-is-in-cart-container text').textContent = totalOfThisItemInCart;
				itemInListing.querySelector('.item-is-in-cart-container').classList.remove('hidden');
			}
		});
	}
	//#endregion

	//#region update cart preview
	if (document.getElementById('cart-preview')) {
		var cartPreview = document.getElementById('cart-preview');
		cartPreview.querySelectorAll('.cart-preview-item').forEach(function(el) {
			el.remove();
		});

		var itemPreviewTemplate = document.getElementById('cart-preview-item-template');

		var creditsAvailableDisplay = document.getElementById('cart-preview-credit-countdown');

		cartData.items.forEach(function(item) {
			var clone = itemPreviewTemplate.content.cloneNode(true);

			var itemTitle = "(" + item.qty + ") " + item.product_name;
			if (item.option_name) { itemTitle += ' - ' + item.option_name; }

			clone.querySelector('li').setAttribute('data-productid', item.purchasable_id);
			clone.querySelector('.cart-preview-item-thumb').style.backgroundImage = 'url(' + item.image_path + ')';
			clone.querySelector('.cart-preview-item-name').textContent = itemTitle;
			clone.querySelector('li').setAttribute('title', itemTitle);
			clone.querySelector('.cart-in-item-badge').textContent = item.qty;

			if (creditsAvailableDisplay) {
				cartPreview.querySelector('ul').insertBefore(clone.querySelector('li'), creditsAvailableDisplay);
			} else {
				cartPreview.querySelector('ul').prepend(clone.querySelector('li'));
			}

		});

		if (cartData.mealcredits) {
			var totalBulkEligibleItemsInCart = cartData.items.filter(function(el) { return el.product.bulk_discount_eligible === 1; }).reduce(function(tot, item) {
				return tot + item.qty;
			}, 0);
			var mealCreditsAvailable = cartData.mealcredits - totalBulkEligibleItemsInCart;
			mealCreditsAvailable = mealCreditsAvailable > 0 ? mealCreditsAvailable : 0;
			cartPreview.querySelector('#cart-preview-credit-countdown span#cart-preview-credits-count').textContent = mealCreditsAvailable;
			if (mealCreditsAvailable !== 1) {
				cartPreview.querySelector('#cart-preview-credits-text').textContent = 'credits';
			} else {
				cartPreview.querySelector('#cart-preview-credits-text').textContent = 'credit';
			}
		}

		
		/* global tooltip */
		tooltip.refresh();
	}
	//#endregion

	if (window.updateCustomerOrderEditDisplay) {
		updateCustomerOrderEditDisplay(cartData); /* global updateCustomerOrderEditDisplay */
	}
	/* global getDifference */
	if (window.getDifference) {
		getDifference();
	}
}

getCartData();



/* Login as customer */
var customerLoginForm = document.querySelector('#checkout-login');
if (customerLoginForm) {
	customerLoginForm.addEventListener('submit', function(e) {
		e.preventDefault();
		var data = new FormData(this);


		var request = new XMLHttpRequest();
		request.open('POST', '/store/customers/login', true);
		request.onload = function() {
			if (request.status >= 200 && request.status < 400) {
				var customerLoginResponse = JSON.parse(this.responseText);
				if (customerLoginResponse.status === "OK") {
					window.location.reload();
				} else {
					alert(customerLoginResponse.status);
				}
			} else {
				alertMessage('AJAX response error in customerLogin', request);
			}
		};
		request.error = function() {
			alertMessage('Server response error in customerLogin', request);
		};
		request.send(data);

		return false;
	});
}





(function() {
	var nutritionForm = document.getElementById('nutrition-coaching-form');
	if (!nutritionForm) { return; }

	braintree.dropin.create({
		authorization: document.getElementById('braintree_client_token').value,
		container: '#card-element',
		paypal: {
			flow: 'vault'
		}
	}, function (createErr, instance) {
		document.getElementById('place-order-button').addEventListener('click', function () {

			if (!document.getElementById('nutrition_agreement').checked) {
				alert("Please agree to the Coach and Client Agreement before continuing.");
				return false;
			}

			instance.requestPaymentMethod(function (requestPaymentMethodErr, payload) {
				if (requestPaymentMethodErr) {
					alert("Please check your payment information and try again.");
					return;
				}
				document.getElementById('payment_method_nonce').value = payload.nonce;
				nutritionForm.submit();
			});
		});
	});
})();


(function() {
	/* https://github.com/dsternlicht/the-ultimate-guide-for-creating-a-simple-modal-in-react-vue-angular-and-vanilla-js/tree/master/vanilla */
	var btn = document.getElementById('modal_opener');
	var modal = document.querySelector('.details-modal');
	
	if (!btn) { return; }

	function attachModalListeners(modalElm) {
	  modalElm.querySelector('.close_modal').addEventListener('click', toggleModal);
	  modalElm.querySelector('.close_modal_second').addEventListener('click', toggleModal);
	  modalElm.querySelector('.overlay').addEventListener('click', toggleModal);
	}
	
	function detachModalListeners(modalElm) {
	  modalElm.querySelector('.close_modal').removeEventListener('click', toggleModal);
	  modalElm.querySelector('.close_modal_second').removeEventListener('click', toggleModal);
	  modalElm.querySelector('.overlay').removeEventListener('click', toggleModal);
	}
	
	function toggleModal() {
	  var currentState = modal.style.display;
	
	  // If modal is visible, hide it. Else, display it.
	  if (currentState === 'none') {
		modal.style.display = 'block';
		document.documentElement.classList.add('has-modal');
		attachModalListeners(modal);
	  } else {
		modal.style.display = 'none';
		detachModalListeners(modal);  
		document.documentElement.classList.remove('has-modal');
	  }
	}
	
	btn.addEventListener('click', toggleModal);
})();

(function() {
	/* https://github.com/dsternlicht/the-ultimate-guide-for-creating-a-simple-modal-in-react-vue-angular-and-vanilla-js/tree/master/vanilla */
	var btn = document.getElementById('sub-confirmation-opener');
	var modal = document.querySelector('.sub-confirmation-modal');
	
	if (!btn) { return; }
	function attachModalListeners(modalElm) {
	  modalElm.querySelector('.close_modal').addEventListener('click', toggleModal);
	  modalElm.querySelector('.overlay').addEventListener('click', toggleModal);
	}
	
	function detachModalListeners(modalElm) {
	  modalElm.querySelector('.close_modal').removeEventListener('click', toggleModal);
	  modalElm.querySelector('.overlay').removeEventListener('click', toggleModal);
	}
	
	function toggleModal() {
	  var currentState = modal.style.display;
	
	  // If modal is visible, hide it. Else, display it.
	  if (currentState === 'none') {
		modal.style.display = 'block';
		attachModalListeners(modal);
	  } else {
		modal.style.display = 'none';
		detachModalListeners(modal);  
	  }
	}
	
	btn.addEventListener('click', toggleModal);
})();



//(function() {
	var menuItemsForEditing = document.querySelectorAll(".menu:not(.menu-single-item) .product, #customer-order-items .product-editable");

//	if (!menuItemsForEditing.length) { return; }
	var modal = document.querySelector('.product-modal');

	if (modal) {
		modal.querySelector('.product-modal-add-button').addEventListener('click', function() {
			var addButton = this;
			var itemsToUpdate = [];
			modal.querySelectorAll('.product-option .product-qty').forEach(function(sel) {
				var optID = sel.getAttribute('data-optionid');
				var otherEl = document.querySelector('.menu [data-productoptionid=\'' + optID + '\'] .product-qty');
				otherEl.value = sel.querySelector.value;
				itemsToUpdate.push({
					option_id: optID,
					qty: sel.value
				});
			});

			updateCartItemQuantities(itemsToUpdate);
			addButton.innerText = 'Updated';
			addButton.classList.add('product-modal-add-button-added');
			window.setTimeout(function() {
				toggleModal();
			}, 500);
		});
	}
	function attachModalListeners(modalElm) {
		modalElm.querySelector('.close_modal').addEventListener('click', toggleModal);
		modalElm.querySelector('.overlay').addEventListener('click', toggleModal);
	}
	
	function detachModalListeners(modalElm) {
		modalElm.querySelector('.close_modal').removeEventListener('click', toggleModal);
		modalElm.querySelector('.overlay').removeEventListener('click', toggleModal);
	}

	function toggleModal(el) {
		var currentState = modal.style.display;

		// If modal is visible, hide it. Else, display it.
		if (currentState === 'none') {
			modal.style.display = 'block';
			attachModalListeners(modal);

			modal.querySelector('.product-name').innerText = el.querySelector('.product-name').innerText;
			modal.querySelector('.product-description').innerText = el.querySelector('.product-description').innerText;
			if (el.querySelector('.product-ingredients')) {
				modal.querySelector('.product-ingredients').innerText = el.querySelector('.product-ingredients').innerText;
			}
			if (modal.querySelector('.product-options')) {
				modal.querySelector('.product-options').remove();
			}
			modal.querySelector('.modal_content .product-options-container').appendChild(el.querySelector('.product-options').cloneNode(true));

			el.querySelectorAll('.product-option').forEach(function(opt) {
				var optID = opt.getAttribute('data-productoptionid');
				modal.querySelectorAll('[data-productoptionid=\'' + optID + '\']').forEach(function(otherOpt) {
					if (otherOpt.querySelectorAll('.product-qty').length) {
						otherOpt.querySelector('.product-qty').value = opt.querySelector('.product-qty').value;
					}
				});
			});
		} else {
			modal.style.display = 'none';
			modal.querySelector('.product-name').innerText = '';
			modal.querySelector('.product-description').innerText = '';
			modal.querySelector('.product-ingredients').innerText = '';
			modal.querySelector('.product-modal-add-button').innerText = 'Add';
			modal.querySelector('.product-modal-add-button').classList.remove('product-modal-add-button-added');

			modal.querySelectorAll('.product-option').forEach(function(opt) {
				if (opt.querySelectorAll('.product-qty')) {
					var optID = opt.getAttribute('data-productoptionid');
					document.querySelectorAll('[data-productoptionid=\'' + optID + '\']').forEach(function(otherOpt) {
						if (otherOpt.querySelectorAll('.product-qty').length) {
							otherOpt.querySelector('.product-qty').value = opt.querySelector('.product-qty').value;
						}
					});
				}
			});

			modal.querySelector('.modal_content .product-options').remove();

			detachModalListeners(modal);
		}
	}
	if (menuItemsForEditing) {
		menuItemsForEditing.forEach(function(el) {
			if (!el.classList.contains("product-not-editable")) { 
				el.addEventListener('click', function() {
					toggleModal(el);
				});
			}
		});
	}
//})();

(function() {
	var cartPreview = document.getElementById('cart-preview');
	if (!cartPreview) { return; }

	document.addEventListener('click', function(e) {
		//#region set theTarget
		var theTarget;
		if (e.target.classList.contains('cart-preview-item')) {
			theTarget = e.target;
		} else if (e.target.closest('.cart-preview-item')) {
			theTarget = e.target.closest('.cart-preview-item');
		} else {
			return;
		}
		//#endregion

		var targetProductID = theTarget.getAttribute('data-productid');
		var theTargetProduct = document.querySelector('.product[data-productid="' + targetProductID + '"]');
		if (theTargetProduct) {
			theTargetProduct.click();
		}
	}, false);
})();

(function() {
	var packageSelectorList = document.getElementById('subscriptions-selector');
	var removeHighlight = function() {
		document.querySelector('.subscription-selector-option.active').classList.remove('active');
		packageSelectorList.removeEventListener('mouseenter', removeHighlight, true);
	};
	if (packageSelectorList) {
		packageSelectorList.addEventListener('mouseenter', removeHighlight, true);
		
	}
})();


/* exported pluralize */
function pluralize(number, one, more) {
	var returnValue = number + " ";
	returnValue += Math.abs(parseFloat(number)) === 1 ? one : more;
	return returnValue;
}












/* Form */
var contactForm = document.querySelector('#contact');
if (contactForm) {
	contactForm.addEventListener('submit', function(e) {
		e.preventDefault();

		var form = this;

		var submit = form.querySelector('input[type=submit]');
		submit.setAttribute('disabled', true);

		var data = new FormData(this);


		if (data.get('name').length === 0) {
			alert("Please enter your name.");
			document.querySelector('#contact_name').focus();
			submit.setAttribute('disabled', false);
			return false;
		}

		if (data.get('email').length === 0 && data.phone.length === 0) {
			alert("Please enter your email or phone so we can get back to you!");
			document.querySelector('#contact_email').focus();
			submit.setAttribute('disabled', false);
			return false;
		}

		if (data.get('message').length === 0) {
			alert("Please enter your message.");
			document.querySelector('#contact_message').focus();
			submit.setAttribute('disabled', false);
			return false;
		}

		var request = new XMLHttpRequest();
		request.open(this.getAttribute('method'), this.getAttribute('action'), true);
		request.onload = function() {
			if (request.status >= 200 && request.status < 400) {
				var response = JSON.parse(request.responseText);

				if (response.status === 'OK') {
					form.innerHTML = response.message;
				} else {
					alert(response.message);
					submit.setAttribute('disabled', false);
				}
			} else {
				alert("There was an error sending your form - please try again.");
				submit.setAttribute('disabled', false);
			}
		};
		request.onerror = function() {
			alert("There was an error sending your form - please try again.");
			submit.setAttribute('disabled', false);
		};

		request.send(data);
		
		return false;
	});
}

/**
 * Tooltip.js
 * A basic script that applies a mouseover tooltip functionality to all elements of a page that have a data-tooltip attribute
 * Matthias Schuetz, http://matthiasschuetz.com
 *
 * Copyright (C) Matthias Schuetz
 * Free to use under the MIT license
 */

(function (root, factory) {
	if (typeof define === "function" && define.amd) {
		// AMD. Register as an anonymous module.
		define(factory);
	} else if (!root.tooltip) {
		// Browser globals
		root.tooltip = factory(root);
	}
}(this, function() {
	var _options = {
		tooltipId: "tooltip",
		offsetDefault: 15
	};

	var _tooltips = [];
	var _tooltipsTemp = null;

	function _bindTooltips(resetTooltips) {
		if (resetTooltips) {
			_tooltipsTemp = _tooltips.concat();
			_tooltips = [];
		}

		Array.prototype.forEach.call(document.querySelectorAll("[data-tooltip]"), function(elm, idx) {
			var tooltipText = elm.getAttribute("title").trim();
			var options;

			if (resetTooltips && _tooltipsTemp.length && _tooltipsTemp[idx] && _tooltipsTemp[idx].text) {
				if (tooltipText.length === 0) {
					elm.setAttribute("title", _tooltipsTemp[idx].text);
					tooltipText = _tooltipsTemp[idx].text;
				}

				elm.removeEventListener("mousemove", _onElementMouseMove);
				elm.removeEventListener("mouseout", _onElementMouseOut);
				elm.removeEventListener("mouseover", _onElementMouseOver);
			}

			if (tooltipText) {
				elm.setAttribute("title", "");
				elm.setAttribute("data-tooltip-id", idx);
				options = _parseOptions(elm.getAttribute("data-tooltip"));
				
				_tooltips[idx] = {
					text: tooltipText,
					options: options
				};

				elm.addEventListener("mousemove", _onElementMouseMove);
				elm.addEventListener("mouseout", _onElementMouseOut);
				elm.addEventListener("mouseover", _onElementMouseOver);
			}
		});

		if (resetTooltips) {
			_tooltipsTemp = null;
		}
	}

	function _createTooltip(text, tooltipId) {
		var tooltipElm = document.createElement("div");
		var tooltipText = document.createTextNode(text);
		var options = tooltipId && _tooltips[tooltipId] && _tooltips[tooltipId].options;

		if (options && options["class"]) {
			tooltipElm.setAttribute("class", options["class"]);
		}

		tooltipElm.setAttribute("id", _options.tooltipId);
		tooltipElm.appendChild(tooltipText);

		document.querySelector("body").appendChild(tooltipElm);
	}

	function _getTooltipElm() {
		return document.querySelector("#" + _options.tooltipId);
	}

	function _onElementMouseMove(evt) {
		var tooltipId = this.getAttribute("data-tooltip-id");
		var tooltipElm = _getTooltipElm();
		var options = tooltipId && _tooltips[tooltipId] && _tooltips[tooltipId].options;
		var offset = options && options.offset || _options.offsetDefault;
		var scrollY = window.scrollY || window.pageYOffset;
		var scrollX = window.scrollX || window.pageXOffset;
		var tooltipTop = evt.pageY + offset;
		var tooltipLeft = evt.pageX + offset;

		if (tooltipElm) {
			tooltipTop = (tooltipTop - scrollY + tooltipElm.offsetHeight + 20 >= window.innerHeight ? (tooltipTop - tooltipElm.offsetHeight - 20) : tooltipTop);
			tooltipLeft = (tooltipLeft - scrollX + tooltipElm.offsetWidth + 20 >= window.innerWidth ? (tooltipLeft - tooltipElm.offsetWidth - 20) : tooltipLeft);

			tooltipElm.style.top = tooltipTop + "px";
			tooltipElm.style.left = tooltipLeft + "px";
		}
	}

	function _onElementMouseOut(evt) {
		var tooltipElm = _getTooltipElm();

		if (tooltipElm) {
			document.querySelector("body").removeChild(tooltipElm);
		}
	}

	function _onElementMouseOver(evt) {
		var tooltipId = this.getAttribute("data-tooltip-id");
		var tooltipText = tooltipId && _tooltips[tooltipId] && _tooltips[tooltipId].text;

		if (tooltipText) {
			_createTooltip(tooltipText, tooltipId);	
		}
	}

	function _parseOptions(options) {
		var optionsObj;

		if (options.length) {
			try {
				optionsObj = JSON.parse(options.replace(/'/ig, "\""));
			} catch(err) {
				console.log(err);
			}
		}

		return optionsObj;
	}

	function _init() {
		window.addEventListener("load", _bindTooltips);
	}

	_init();

	return {
		setOptions: function(options) {
			for (var option in options) {
				if (_options.hasOwnProperty(option)) {
					_options[option] = options[option];
				}
			}
		},
		refresh: function() {
			_bindTooltips(true);
		}
	};
}));

document.querySelectorAll('.password-reveal').forEach(function(btn) {
	btn.addEventListener('click', function() {
		var passwordEl = btn.previousElementSibling;
		if (passwordEl.getAttribute('type') === 'password') {
			passwordEl.setAttribute('type', 'text');
		} else {
			passwordEl.setAttribute('type', 'password');
		}
	});
});
//#region error block
function ajaxLoginFormGetErrorBlock(form) {
	return form.querySelector('.sk-form-error');
}

function ajaxLoginFormShowError(form, title, message) {
	var errorBlock = ajaxLoginFormGetErrorBlock(form);
	errorBlock.querySelector('.sk-form-error-title').innerText = title;
	errorBlock.querySelector('.sk-form-error-message').innerText = message;
	errorBlock.classList.remove('hidden');
}

function ajaxLoginFormHideError(form) {
	var errorBlock = form.querySelector('.sk-form-error');
	errorBlock.querySelector('.sk-form-error-title').innerText = '';
	errorBlock.querySelector('.sk-form-error-message').innerText = '';
	errorBlock.classList.add('hidden');
}
//#endregion

//#region submit button
function ajaxLoginFormDisableSubmitButton(button) {
	button.classList.add('disabled');
	button.setAttribute('disabled', 'disabled');
}

function ajaxLoginFormEnableSubmitButton(button) {
	button.classList.remove('disabled');
	button.removeAttribute('disabled');
}
//#endregion

//#region formdata
// function ajaxLoginBuildFormData(form) {
// 	var formActionType = document.querySelector("input[name=sk_ajax_form_action_type]:checked").value;
// 	if (formActionType === 'login') {
// 		return ajaxLoginBuildLoginFormData(form);
// 	} else {
// 		return ajaxLoginBuildNewCustomerFormData(form);
// 	}
// }

// function ajaxLoginBuildLoginFormData(form) {
// 	var loginFD = new FormData();
// 	loginFD.set('username', form.querySelector('#login-email').value);
// 	loginFD.set('password', form.querySelector('#login-password').value);

// 	return loginFD;
// }

function ajaxLoginBuildNewCustomerFormData(form) {
	var customerFD = new FormData(form);
	return customerFD;
}

function ajaxLoginBuildCustomerTestFormData(form) {
	var customerTestFD = new FormData();
	customerTestFD.set('username', form.querySelector('#new-email').value);
	customerTestFD.set('password', form.querySelector('#new-password').value);

	return customerTestFD;
}
//#endregion


document.querySelectorAll('.sk-ajax-login-form-create-account').forEach(function(form) {
	form.addEventListener('submit', function(e) {
		e.preventDefault();

		var currentState = form.getAttribute('data-state');

		if (currentState === 'initial' || !currentState || currentState === 'login') {
			doAccountLoginTest(form);
		} else if (currentState === 'customer-info') {
			var newCustomerFD = ajaxLoginBuildNewCustomerFormData(form);

			var request = new XMLHttpRequest();
			request.open('POST', form.getAttribute('action'), true);
			request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
			request.onload = function() {
				var response = JSON.parse(this.responseText);
				if (request.status >= 200 && request.status < 400) {
					window.location.href = window.location.href;
				} else {
					ajaxLoginFormEnableSubmitButton(form.querySelector('input[type=submit]'));
					ajaxLoginFormShowError(form, response.errorTitle, response.errorMessage);
				}
			};
			request.onerror = function() {
				ajaxLoginFormEnableSubmitButton(form.querySelector('input[type=submit]'));
				ajaxLoginFormShowError(form, "Something went wrong", "There was an error processing your login. Please try again.");
			};

			ajaxLoginFormHideError(form);
			ajaxLoginFormDisableSubmitButton(form.querySelector('input[type=submit]'));
			request.send(newCustomerFD);
		}

		return false;
	});
});


/* Does the account exist already? If so, log them in. */
function doAccountLoginTest(form) {
	var submitButton = form.querySelector('input[type=submit]');
	var accountData = ajaxLoginBuildCustomerTestFormData(form);
	var request = new XMLHttpRequest();

	request.open('POST', form.getAttribute('action'), true);
	request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	request.onload = function() {
		var response = JSON.parse(this.responseText);
		if (request.status >= 200 && request.status < 400) {
			// Customer is logged in.
			window.location.href = window.location.href;
		} else if (request.status === 401) { //unauthorized
			if (response.errorDetail === 'has_account') {
				ajaxLoginFormEnableSubmitButton(submitButton);
				ajaxLoginFormShowError(form, 'Wrong password', 'Please try again.');
			} else {
				form.setAttribute('data-state', 'customer-info');
				form.setAttribute('action', '/store/customers/create_account');
				ajaxLoginFormEnableSubmitButton(submitButton);
			}
		} else {
			ajaxLoginFormEnableSubmitButton(submitButton);
			ajaxLoginFormShowError(form, response.errorTitle, response.errorMessage);
		}
	};
	request.onerror = function() {
		ajaxLoginFormEnableSubmitButton(submitButton);
		ajaxLoginFormShowError(form, "Something went wrong", "There was an error processing your login. Please try again.");
	};

	ajaxLoginFormHideError(form);
	ajaxLoginFormDisableSubmitButton(submitButton);
	request.send(accountData);
}


/* Login type */
document.querySelectorAll('.login-type-switch').forEach(function(el) {
	el.addEventListener('click', function() {
		var form = el.closest('form');
		var currentFormState = form.getAttribute('data-state');

		ajaxLoginFormEnableSubmitButton(form.querySelector('input[type=submit]'));
		ajaxLoginFormHideError(form);
		
		if (!currentFormState || currentFormState === 'initial' || currentFormState === 'customer-info') {
			form.setAttribute('data-state', 'login');
			form.querySelector('.sk-ajax-login-form-intro .content-title').textContent = 'Log In';
			el.textContent = 'I need an account.';
			document.getElementById('ajax-login-forgot-password').classList.remove('hidden');
		} else {
			form.setAttribute('data-state', 'initial');
			form.querySelector('.sk-ajax-login-form-intro .content-title').textContent = 'Get Started';
			el.textContent = 'I already have an account.';
			document.getElementById('ajax-login-forgot-password').classList.add('hidden');
		}
	});
});
